import axios from "axios";

const baseURL = "https://api.vault56.com/v1";

export async function v56a_register(
    email,
    first_name,
    last_name,
    password,
    comment,
    key,
    validation_link
) {

    const url =
        baseURL + '/register/account';

    const bodyFormData = new FormData();
    bodyFormData.append('email', email);
    bodyFormData.append('first_name', first_name);
    bodyFormData.append('last_name', last_name);
    bodyFormData.append('password', password);
    bodyFormData.append('comment', comment);
    bodyFormData.append('key', key);
    bodyFormData.append('validation_link', validation_link);
    try {
        return await axios
            .post(url, bodyFormData, {
                data: bodyFormData
            });
    } catch (e) {
        return e.response;
    }

}
